import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { ErrorBoundaryElement } from '@components/ErrorBoundaryElement';
import { MainLayout } from '@components/layout';
import { clubHouseRoutes } from '@views/ClubHouseReservationPage/clubHouse.routes';
import { contractRoutes } from '@views/ContractPage/contractPage.routes';
import { loginRoutes } from '@views/login/login.routes';
import { messagesRoutes } from '@views/MessagesPage/messages.routes';
import { myInformationRoutes } from '@views/myInfo/myInformation.routes';
import { parkingRoutes } from '@views/parking/parking.routes';
import { Redirect } from '@views/Redirect';
import { saunaRoutes } from '@views/sauna/sauna.routes';

import { PrivateRoute } from './PrivateRoute';
import { FIXED_PATHS, ROUTES } from './routes.constants';

const browserRouter = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    errorElement: <ErrorBoundaryElement />,
    children: [
      {
        path: '/',
        element: <PrivateRoute />,
        children:
          // Private routes
          [
            ...myInformationRoutes,

            ...messagesRoutes,

            ...saunaRoutes,

            ...contractRoutes,

            ...clubHouseRoutes,

            ...parkingRoutes,

            {
              path: ROUTES.APARTMENT,
              lazy: async () => ({
                Component: (await import('@views/ApartmentPage')).ApartmentPage,
              }),
            },

            {
              path: ROUTES.REAL_ESTATE_AND_COMMON_SPACES,
              lazy: async () => ({
                Component: (
                  await import(
                    '@views/RealEstateAndCommonSpacesPage/RealEstateAndCommonSpacesPage'
                  )
                ).RealEstateAndCommonSpacesPage,
              }),
            },

            {
              path: FIXED_PATHS.MY_HOME,
              lazy: async () => ({
                Component: (await import('@/contentful/ContentfulPage'))
                  .ContentfulPage,
              }),
            },

            {
              path: `${FIXED_PATHS.MY_HOME}/*`,
              lazy: async () => ({
                Component: (await import('@/contentful/ContentfulPage'))
                  .ContentfulPage,
              }),
            },

            {
              path: FIXED_PATHS.USERS_CONTRACT_HAS_ENDED,
              lazy: async () => ({
                Component: (await import('@/contentful/ContentfulPage'))
                  .ContentfulPage,
              }),
            },
          ],
      },

      // Public routes
      ...loginRoutes,

      { path: ROUTES.REDIRECT, element: <Redirect /> },

      {
        path: ROUTES.FTN_AUTHENTICATION,
        lazy: async () => ({
          Component: (await import('@/views/FTNAuthenticationPage'))
            .FTNAuthenticationPage,
        }),
      },

      {
        index: true,
        lazy: async () => ({
          Component: (await import('@/contentful/ContentfulPage'))
            .ContentfulPage,
        }),
      },

      {
        path: '*',
        lazy: async () => ({
          Component: (await import('@/contentful/ContentfulPage'))
            .ContentfulPage,
        }),
      },
    ],
  },
]);

export const Router = () => <RouterProvider router={browserRouter} />;
